module.exports = __webpack_public_path__ + "static/img/headerImg2.88a98608.png";